
const servicesData = [
    {
      id: 1,
      title: "Web Development",
      description: "Building Future-Ready Websites – Where Innovation Meets Functionality!",
      icon: "FaCode", // Use the React Icon name
    },
    {
      id: 2,
      title: "Digital Marketing",
      description: "Boost Your Online Presence – Strategic Digital Marketing That Delivers Results!",
      icon: "FaBullhorn", 
    },
    {
      id: 3,
      title: "SEO Services",
      description: "Rank Higher, Reach Further – Expert SEO Services for Maximum Visibility!",
      icon: "FaSearch", 
    },
    {
        id: 4,
        title: "Social Media Managment",
        description: "Engage, Grow, Succeed – Smart Social Media Management for Your Brand!",
        icon: "MdPhoneAndroid", 
      },
      {
        id: 5,
        title: "Video Adverertisement",
        description: "Captivate Your Audience – Powerful Video Advertisements That Inspire Action! ",
        icon: "RiAdvertisementFill", 
      },
      {
        id: 6,
        title: "Graphic Desgin",
        description: "Designs That Speak Volumes – Creative Graphics for a Lasting Impression!",
        icon: "SiAdobephotoshop",
      },
      {
        id: 7,
        title: "Logo Desgin",
        description: "Crafting Icons of Identity – Unique Logo Designs That Define Your Brand!",
        icon: "PiCodesandboxLogoLight", 
      },
      {
        id: 8,
        title: "Video Editing",
        description: "Transform Your Footage – Professional Video Editing That Tells Your Story!",
        icon: "MdVideoChat", 
      },
  ];
  
  export default servicesData;
  